import { useI18n } from "@/composables/useI18n";
import type { FirebaseError } from "firebase/app";
import { AuthErrorCodes } from "firebase/auth";

export function useFirebaseErrorMessage() {
  const { t } = useI18n();

  const getFirebaseErrorMessage = (error: FirebaseError): string => {
    if (error.code === AuthErrorCodes.INVALID_LOGIN_CREDENTIALS)
      return t("login.invalidCredentials");
    if (error.code === AuthErrorCodes.EMAIL_EXISTS) return t("signup.accountAlreadyExists");
    const match = /^Firebase: (.+) \(.*\)\.$/.exec(error.message);
    if (match && match[1]) {
      const message = match[1].trim();
      if (message !== "" && message !== "Error") return message;
    }
    return error.code.replace("auth/", "").replace("functions/", "").replace(/-/g, " ");
  };
  return { getFirebaseErrorMessage };
}
